






























import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
  name: 'AlTooltipBtn',

  props: {
    icon: {
      type: String
    },
    text: {
      type: String
    },
    iconSize: {
      type: Number
    },
    tooltipDisabled: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const parentRef = ref<HTMLSpanElement>();
    return { parentRef };
  }
});
